export const resolveInstalledAppUrl = ({
  search,
  launchUrl,
}: {
  search: string;
  launchUrl?: string;
}): string | undefined => {
  const urlParamIndex = search.indexOf("url=");

  if (urlParamIndex === -1 || !launchUrl) {
    return launchUrl;
  }

  const nestedUrl = decodeURIComponent(search.slice(urlParamIndex + 4));

  try {
    return new URL(launchUrl).origin + nestedUrl;
  } catch {
    return launchUrl;
  }
};
